const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const fullMonth = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const LEXICON = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz'

export default function(date, full, year) {
    if (date == null || typeof date !== 'string') return ''

    var time = 0
    for (var i = 0 ; i < 8 ; i++) {
        time += Math.pow(64, 8 - i - 1) * LEXICON.indexOf(date.charAt(i))
    }
    date = new Date(time)

    if(new Date().getFullYear() !== date.getFullYear())
        year = true

    return (full ? fullMonth : months)[date.getMonth()] + ' ' + date.getDate() + (year ? (', ' + (1900 + date.getYear())) : '')
}
